import React, { memo } from 'react';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import { ExternalApps } from '@olxeu-a2b/core/typings/components';
import S from './style/LabellessInfo';
import LabellessIcon from './images/labelless.svg';
import TooltipIcon from './images/tooltip.svg';
import IosAppSvg from './images/ios_app.svg';
import AndroidApp from './images/android_app.svg';

interface MobileLinkProps {
  iosAppLink: string;
  androidAppLink: string;
}

// Detects the current user agent (android, iphone, ipad etc)
const MobileLink: React.FC<MobileLinkProps> = ({ children, iosAppLink, androidAppLink }) => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('android')) {
    return (
      <a href={androidAppLink} target="new">
        {children}
      </a>
    );
  }

  if (/iphone|ipod|ipad/.test(userAgent)) {
    return (
      <a href={iosAppLink} target="new">
        {children}
      </a>
    );
  }

  return <>{children}</>;
};

interface Props {
  desktop: boolean;
  externalApps: Readonly<ExternalApps> | undefined;
}
const LabellessInfo: React.FC<Props> = ({ desktop, externalApps }) => {
  const i18n = useI18n();

  const androidAppLink =
    externalApps?.android ?? i18n`dlv_orders_shipment_opt_labelless_app_link_android`;
  const iosAppLink = externalApps?.ios ?? i18n`dlv_orders_shipment_opt_labelless_app_link_ios`;

  return (
    <S.LabellessInfoBlock>
      <figure>
        <LabellessIcon />
      </figure>
      <div>
        <header>
          <S.LabellessTitle>
            <span>{i18n`dlv_orders_shipment_opt_labelless_title`}</span>
            <TooltipIcon />
          </S.LabellessTitle>
        </header>
        <S.LabellessDescription>
          {i18n`dlv_orders_shipment_opt_labelless_description_before_app_link`}
          {desktop ? (
            <span>{i18n`dlv_orders_shipment_opt_labelless_description_app_link_text`}</span>
          ) : (
            <MobileLink androidAppLink={androidAppLink} iosAppLink={iosAppLink}>
              {i18n`dlv_orders_shipment_opt_labelless_description_app_link_text`}
            </MobileLink>
          )}
          {i18n`dlv_orders_shipment_opt_labelless_description_after_app_link`}
        </S.LabellessDescription>
      </div>
      {!desktop ? (
        <S.MobileAppBlock>
          <S.MobileAppLinksTitle>
            {i18n`dlv_orders_shipment_opt_labelless_app_link_title_icons`}
          </S.MobileAppLinksTitle>
          <div>
            <a href={iosAppLink} target="new">
              <IosAppSvg />
            </a>
            <a href={androidAppLink} target="new">
              <AndroidApp />
            </a>
          </div>
        </S.MobileAppBlock>
      ) : null}
    </S.LabellessInfoBlock>
  );
};

export default memo(LabellessInfo);
